var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M23.2 12.146c-.043.326.134.132-2.946 3.219a290 290 0 0 1-2.936 2.92c-.176.142-.35.199-.606.199a.9.9 0 0 1-.356-.055 1.07 1.07 0 0 1-.605-.652 1.1 1.1 0 0 1 .049-.693c.065-.147.176-.263 2.026-2.118l1.957-1.962H10.77c-5.733 0-9.063-.009-9.154-.024a1.03 1.03 0 0 1-.74-.568C.807 12.26.8 12.23.8 11.996s.006-.263.078-.415c.14-.297.427-.518.74-.57.09-.014 3.42-.023 9.154-.023h9.01l-1.956-1.962c-1.85-1.853-1.961-1.97-2.026-2.118a1.1 1.1 0 0 1-.047-.7c.157-.477.639-.78 1.11-.696.348.06.136-.133 3.264 2.99 1.575 1.572 2.896 2.907 2.935 2.966.12.18.172.432.139.678",
  clipRule: "evenodd"
})));
export default SvgArrowRight;